import { Animated } from "react-native";

export const animateBounce = (anim: Animated.Value) => {
  Animated.sequence([
    Animated.timing(anim, {
      toValue: 1.3,
      duration: 150,
      useNativeDriver: true,
    }),
    Animated.timing(anim, {
      toValue: 1,
      duration: 150,
      useNativeDriver: true,
    }),
  ]).start();
};

/**
 * Returns the running loop so a caller can `stop()` it — an unstopped
 * `Animated.loop` keeps a timer alive after its component unmounts.
 */
export const animatePulse = (anim: Animated.Value) => {
  const loop = Animated.loop(
    Animated.sequence([
      Animated.timing(anim, {
        toValue: 1,
        duration: 600,
        useNativeDriver: true,
      }),
      Animated.timing(anim, {
        toValue: 0.3,
        duration: 600,
        useNativeDriver: true,
      }),
    ]),
  );
  loop.start();
  return loop;
};
